module.exports = __webpack_public_path__ + "static/media/test1000.b502efb5.JPG";